import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export interface UsageData {
  total_credits: number;
  used_credits: number;
  remaining_credits: number;
  usage_history: any[];
  monthly_usage: any[];
  // Campos adicionais da API
  available_tokens?: number;
  tokens_per_credit?: number;
  total_tokens?: number;
  total_documents?: number;
  payment_history?: any[];
  chat_history?: any[];
  document_history?: any[];
}

/**
 * Hook para buscar dados de uso/créditos
 */
export function useUsageData() {
  return useQuery<UsageData>({
    queryKey: ['usage'],
    queryFn: async () => {
      const response = await api.get('/usage');
      return response.data;
    },
    staleTime: 1 * 60 * 1000, // 1 minuto
    refetchInterval: 60000, // Refetch a cada minuto
  });
}

/**
 * Hook para buscar estatísticas de uso
 */
export function useUsageStats() {
  return useQuery({
    queryKey: ['usage', 'stats'],
    queryFn: async () => {
      const response = await api.get('/usage/stats');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}





